<template>
    <div class="border-b border-v2-gray-110 pb-5 pt-8 px-6 dark:border-v2-gray-10">
        <div class="flex items-center gap-2">
            <h2 class="flex gap-1 items-center font-medium mr-auto text-v2-gray-20 dark:text-v2-white">
                <span>{{ $t('All Pins') }}</span>
            </h2>
            <div class="relative">
                <AppButton
                    @click="dropdown==='more'?dropdown=false:dropdown = 'more'"
                    icon="ExportFile"
                    icon-only="true"
                    text="Export trays"
                    :tooltip="{ text: 'Export trays', side: 'left' }"
                    aria-label="Export trays"
                />
                <TrayActionMenu
                    :tray="drawer.selected_tray"
                    :open="dropdown==='more'"
                    @close="closeDropdown"
                    :hasExportAll="true"
                />
            </div>
            <AppButton
                @click="closeDrawer"
                icon="Close"
                icon-only="true"
            >
                <BaseSvg name="Close" aria-hidden="true" class="fill-v2-gray-70 size-6 dark:fill-v2-gray-90"/>
                <span class="sr-only">Close</span>
            </AppButton>
        </div>
        <div class="grid grid-cols-2 gap-3">
            <SearchInput
                class="bg-v2-gray-130 border-v2-gray-110 mt-3 dark:bg-v2-gray-30 dark:border-v2-gray-10 !h-[34px]"
                placeholder="Search Pins and Trays"
                :large="true"
                v-model="computedSearchInput"
            />
            <SeclockMultiselect
                :disabled="!drawer.pins.length"
                v-model="computedSortValue"
                :options="searchSortOptions"
                :option-is-object="true"
                :label="$t('Sort')"
                class="flex !w-full mt-3"
                :can-deselect="false"
                label-position="side"
                :contrast="true"
                :hideSelected="true"
            />
        </div>
        
    </div>
</template>

<script setup>
import {SearchInput, SeclockMultiselect, TrayActionMenu, AppButton} from "@/Components";
import {useDialog, usePinsDrawer} from "@/Composables";
import {computed, ref} from "vue";

const props = defineProps(['modelValue','sortValue']);
const emit = defineEmits(["update:modelValue","update:sortValue"]);

const {drawer, closeTray} = usePinsDrawer();
const dropdown = ref(null);
const {forceClose} = useDialog();

function closeDrawer(event) {
    closeTray()
    forceClose(event)
}

function closeDropdown() {
    dropdown.value = false;
}

const searchSortOptions = ref([
    {value: ['created_at', 'desc'], label: 'Date (desc)'},
    {value: ['created_at', 'asc'], label: 'Date (asc)'},
    {value: ['name', 'asc'], label: 'Name (A→Z)'},
    {value: ['name', 'desc'], label: 'Name (Z→A)'},
]);

const computedSearchInput = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val),
});

const computedSortValue = computed( {
    get: () => props.sortValue,
    set: (val) => emit('update:sortValue', val),
})
</script>
